<template>
  <div style="padding-top: 50px; position: relative;">
    <div class="store-search-container">
      <el-form :inline="true">
        <el-form-item label="产品">
          <el-select v-model="query.productId" filterable placeholder="请选择产品" style="width: 300px;" @change="handlerProductChange">
            <el-option v-for="item in products" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页码" style="margin-left: 30px;">
          <el-select v-model="query.pageCode" multiple placeholder="页码" style="width: 300px;">
            <el-option v-for="item in pageCodes" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="品番" style="margin-left: 30px;">
          <el-select v-model="query.designation" placeholder="品番" clearable style="width: 300px;">
            <el-option v-for="(item, index) in designations" :key="index" :label="item.merchandiseNumber" :value="item.merchandiseNumber"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handlerQueryLocation">查询</el-button>
          <el-button type="warning" @click="handlerClear">清空</el-button>
          <el-button type="success" @click="handlerRefresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
    <table class="second-area" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
          <td rowspan="10" style="background: #ff0; border-top: 1px solid #ff0; border-right: 1px solid #ff0;">电梯</td>
          <td rowspan="10" style="background: #fc0; border-top: 1px solid #fc0; border-right: 1px solid #fc0;">治具</td>
          <td colspan="1" rowspan="2" style="width: 40px;">1</td>
          <td style="width: 30px;">上</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '1-2'">{{item}}1-2</td>
        </tr>
        <tr class="location-down">
          <td style="width: 30px;">下</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '1-1'">{{item}}1-1</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="2" style="width: 40px;">2</td>
          <td style="width: 30px;">上</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '2-2'">{{item}}2-2</td>
        </tr>
        <tr class="location-down">
          <td style="width: 30px;">下</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '2-1'">{{item}}2-1</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="2" style="width: 40px;">3</td>
          <td style="width: 30px;">上</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '3-2'">{{item}}3-2</td>
        </tr>
        <tr class="location-down">
          <td style="width: 30px;">下</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '3-1'">{{item}}3-1</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="2" style="width: 40px;">4</td>
          <td style="width: 30px;">上</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '4-2'">{{item}}4-2</td>
        </tr>
        <tr class="location-down">
          <td style="width: 30px;">下</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '4-1'">{{item}}4-1</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="2" style="border-bottom: 1px solid #333; width: 40px;">5</td>
          <td style="width: 30px;">上</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '5-2'">{{item}}5-2</td>
        </tr>
        <tr class="location-down last-location">
          <td style="width: 30px;">下</td>
          <td v-for="(item, index) in columnNames" :key="index" :id="item + '5-1'">{{item}}5-1</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style>
  #app {
    overflow: auto;
  }
</style>
<style scoped>
  .store-search-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    background-color: #fff;
    padding: 5px 0;
  }
  .el-form .el-form-item {
    margin-left: 0;
    margin-bottom: 0;
  }
  table.second-area {
    width: auto;
    margin: 0 auto;
  }
  table.second-area tr {
    height: 50px;
  }
  table.second-area td {
    width: 68px;
    border-width: 1px;
    border-style: solid;
    border-color: #333;
    border-left: none;
    border-bottom: none;
  }
  table.second-area tr.location-down > td {
    border-top-style: dashed;
  }
  table.second-area tr.last-location > td {
    border-bottom: 1px solid #333;
  }
  td.current {
    background-color: #00a;
    color: #fff;
    cursor: pointer;
  }
  td.outbound {
    background-color: #0a0;
    color: #fff;
  }
</style>
<script>
export default {
  data: function () {
    return {
      query: {
        storageCategory: 'second',
        // 产品Id
        productId: '',
        // 页码
        pageCode: [],
        // 番号
        designation: ''
      },
      dataList: [],
      // 所有产品
      products: [],
      pageCodes: [],
      designations: [],
      columnNames: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X'],
      outboundDialogShow: false,
      // 是否做过搜索，如果做过搜索，当清空搜索条件的时候，则要重新搜索，否则，只需要清空搜索条件即可
      isSearched: false
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData: function () {
      const _this = this
      _this.post(_this.$apis.getProducts, {}, function (res) {
        const _json = res.data
        _this.products = _json.products
      })
    },
    handerOutbound: function (positionNo, dom) {
      const _this = this
      _this.$confirm('出库操作不可逆, 确定出库?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // ajax提交至服务器，删除数据
        _this.post(_this.$apis.outBound, { category: '1', cage_codes: [positionNo] }, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
              dom.className = 'outbound'
              dom.onclick = null
            } else {
              _this.$message({
                type: 'error',
                message: '无数据更新!'
              })
            }
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handlerClear: function () {
      this.query = {
        storageCategory: 'second',
        // 产品Id
        productId: '',
        // 页码
        pageCode: [],
        // 番号
        designation: ''
      }
      if (this.isSearched) {
        this.handlerQueryLocation()
      }
    },
    // 刷新事件
    handlerRefresh: function () {
      this.loadData()
      if (this.isSearched) {
        this.handlerQueryLocation()
      }
    },
    handlerGetPageCode: function () {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getPageCodes, { productId: _this.query.productId }, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    handlerProductChange: function (val) {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getPageCodes, { productId: val }, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    // 根据产品名称、页码、番号，获取对应的库位
    handlerQueryLocation: function () {
      const _this = this
      let allTd = document.getElementsByTagName('td')
      for (let i = 0; i < allTd.length; ++i) {
        allTd[i].className = ''
      }
      let locationNumbers = []
      _this.post(_this.$apis.getStorageLocations, _this.query, function (res) {
        const _json = res.data
        // 获取到的库位号
        locationNumbers = _json.storageLocations
        if (locationNumbers.length > 0) {
          for (let i = 0; i < locationNumbers.length; ++i) {
            let _id = locationNumbers[i]
            let domTd = document.getElementById(_id)
            domTd.className = 'current'
            /*
            domTd.onclick = function () {
              _this.handerOutbound(_id, domTd)
            }
            */
          }
          _this.isSearched = true
        } else {
          _this.isSearched = false
        }
      })
    }
  },
  components: {
  }
}
</script>
